// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2570":"css/admin-app.6716","8210":"css/app.6716"}[chunkId] + ".css";
};